import React, { useEffect, useState } from 'react';
import API_URL from '../api/APIUrl';
import { useStudentAuthContext } from '../student/useStudentAuthContext';
import { Circles } from 'react-loader-spinner'

const StudentDocument = () => {

    const {studentuser} = useStudentAuthContext();

    const [student_id, setStudentId] = useState('');
    const [father_aadhar_file, setFatherAadharFile] = useState('');
    const [mother_aadhar_file, setMotherAadharFile] = useState('');
    const [student_aadhar_file, setStudentAadharFile] = useState('');
    const [student_income_file, setStudentIncomeFile] = useState('');

    const [father_aadhar_file_link, setFatherAadharFileLink] = useState('');
    const [mother_aadhar_file_link, setMotherAadharFileLink] = useState('');
    const [student_aadhar_file_link, setStudentAadharFileLink] = useState('');
    const [student_income_file_link, setStudentIncomeFileLink] = useState('');

    const [sub_caste, setSubCaste] = useState('');

    const [father_its_file, setFatherITSFile] = useState('');
    const [mother_its_file, setMotherITSFile] = useState('');
    const [student_its_file, setStudentITSFile] = useState('');

    const [father_its_file_link, setFatherITSFileLink] = useState('');
    const [mother_its_file_link, setMotherITSFileLink] = useState('');
    const [student_its_file_link, setStudentITSFileLink] = useState('');

    const [emptyFields, setEmptyFields] = useState([]);
    const [error,setError] = useState(null);
    const [msg,setMsg] = useState(null);
    const [isSaved, setIsSaved] = useState(false);
    const [loading, setLoading] = useState(false); // Loading state

    var json;


  // This useEffect will run each time `isSaved` is updated
  useEffect(() => {
    if (isSaved) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setIsSaved(false); // Reset the save status after scrolling
    }
  }, [isSaved]);
 

    useEffect(() =>{
        const fetchStudentData = async () =>{
            try {
              console.log(API_URL.GET_SINGLE_STUDENT_BY_EMAIL + "/" + studentuser.email);
                const response = await fetch(API_URL.GET_SINGLE_STUDENT_BY_EMAIL + "/" + studentuser.email,{
                    method: 'GET', 
                    headers:{
                        'Content-Type' : 'application/json',
                        'Authorization': `Bearer ${studentuser.token}` 
                    },
                });
                json = await response.json();
                if(!response.ok){
                    setMsg('');
                    setError(json.error);        
                }
                if(response.ok){
                    setStudentId(json._id);
                    setSubCaste(json.sub_caste);
                    setError(null);
                    setMsg(json.message);
                    console.log("Student Data Fetched By Email: ",json);
                }
    
               // console.log("FetchOutput " + json.error);
            } catch (error) {
                setError(json.error);
            }
        }
        fetchStudentData();
      },[json]);


    useEffect(() =>{
        const fetchStudentDocumentData = async () =>{
            try {
                const response = await fetch(API_URL.GET_STUDENT_DOCUMENT + "/" + student_id,{
                    method: 'GET', 
                    headers:{
                        'Content-Type' : 'application/json',
                        'Authorization': `Bearer ${studentuser.token}` 
                    },
                });
                json = await response.json();
                if(!response.ok){
                    setMsg('');
                    setError(json.error);        
                }
                if(response.ok){
                  //  setStudentId(json.student_id);
                    if(json.father_aadhar_file){
                        setFatherAadharFileLink(API_URL.DOCUMENT_URL+ json.father_aadhar_file);
                    }
                    if(json.mother_aadhar_file){
                        setMotherAadharFileLink(API_URL.DOCUMENT_URL+ json.mother_aadhar_file);
                    }
                    if(json.student_aadhar_file){
                        setStudentAadharFileLink(API_URL.DOCUMENT_URL+ json.student_aadhar_file);
                    }

                    if(json.student_income_file){
                      setStudentIncomeFileLink(API_URL.DOCUMENT_URL+ json.student_income_file);
                  }
                    

                    if(sub_caste==="Dawoodi Bohra"){
                        if( json.father_its_file){
                            setFatherITSFileLink(API_URL.DOCUMENT_URL+ json.father_its_file);
                        }
                        if(json.mother_its_file){
                            setMotherITSFileLink(API_URL.DOCUMENT_URL+ json.mother_its_file);
                        }
                        if(json.student_its_file){
                            setStudentITSFileLink(API_URL.DOCUMENT_URL+ json.student_its_file);
                        }
                        
                    }

                    setError(null);
                    setMsg(json.message);
                    console.log("Student Document Data Fetched By Id: ",student_id);
                }
    
               // console.log("FetchOutput " + json.error);
            } catch (error) {
                setError(error.message);
            }
        }
        fetchStudentDocumentData();
      },[student_id]);

      const handleFatherAadharFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          setFatherAadharFile(file);
          setFatherAadharFileLink(URL.createObjectURL(file));
        }
      };

      const handleMotherAadharFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          setMotherAadharFile(file);
          setMotherAadharFileLink(URL.createObjectURL(file));
        }
      };

      const handleStudentAadharFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          setStudentAadharFile(file);
          setStudentAadharFileLink(URL.createObjectURL(file));
        }
      };

      const handleStudentIncomeFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          setStudentIncomeFile(file);
          setStudentIncomeFileLink(URL.createObjectURL(file));
        }
      };

      const handleFatherITSFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          setFatherITSFile(file);
          setFatherITSFileLink(URL.createObjectURL(file));
        }
      };

      const handleMotherITSFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          setMotherITSFile(file);
          setMotherITSFileLink(URL.createObjectURL(file));
        }
      };

      const handleStudentITSFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
          setStudentITSFile(file);
          setStudentITSFileLink(URL.createObjectURL(file));
        }
      };




      const handleSubmit = async (event) => {
        try{
          event.preventDefault();
          setLoading(true);
  
          const formStudentDocumentData = new FormData();
          if(father_aadhar_file){
              formStudentDocumentData.append('father_aadhar_file', father_aadhar_file); // Append the file as 'father_aadhar_file'
          }
          if(mother_aadhar_file){
            formStudentDocumentData.append('mother_aadhar_file', mother_aadhar_file); // Append the file as 'mother_aadhar_file'
          }
          if(student_aadhar_file){
            formStudentDocumentData.append('student_aadhar_file', student_aadhar_file); // Append the file as 'mother_aadhar_file'
          }

          if(student_income_file){
            formStudentDocumentData.append('student_income_file', student_income_file); // Append the file as 'student_income_file'
          }

          if(father_its_file){
            formStudentDocumentData.append('father_its_file', father_its_file); // Append the file as 'father_aadhar_file'
             }
            if(mother_its_file){
            formStudentDocumentData.append('mother_its_file', mother_its_file); // Append the file as 'mother_aadhar_file'
            }
            if(student_its_file){
            formStudentDocumentData.append('student_its_file', student_its_file); // Append the file as 'mother_aadhar_file'
            }

          const response = await fetch(API_URL.POST_STUDENT_DOCUMENT + "/" + student_id,{
            method: 'POST', 
            headers:{
                //'Content-Type' : 'application/json',
                'Authorization': `Bearer ${studentuser.token}` 
            },
           // body: JSON.stringify(studentData),
           body: formStudentDocumentData,
           
           
        });
        const json = await response.json();

        if(!response.ok){
            setMsg('');
            setError(json.error);
            if(json.requiredFields){
                setEmptyFields(json.requiredFields);
                console.log(json.requiredFields);
            }    
            setIsSaved(true);     
            setLoading(false);      
        }
        if(response.ok){
            setError(null);
            setMsg(json.message);
            setEmptyFields([]);
            console.log("Documents Upload Edited",json)
            setIsSaved(true);
            setLoading(false); 
            //json="invoke";
    
        }
  
  
        }
        catch (error) {
          setError(error.message);
          setLoading(false); 
          setIsSaved(true);
      }
    };
  

    return (
        <form style={styles.form}>
        <h2 style={styles.title}>Student Documents</h2>
        {error && <div className="error-message">{error}</div>}
        {msg && <div className="success-message">{msg}</div>}
  
       <h4>Please ensure that all of the documents are uploaded correctly otherwise the admin will permanently reject your application. </h4>
  
        <div style={styles.fieldRow}>
           
          <div style={styles.fieldContainer}>
            <label style={styles.label}>Upload Fathers Aadhar</label>
            <input
             type="file" 
             id="father_aadhar_file" 
             onChange={handleFatherAadharFileChange}   
            style={styles.input} />
              {father_aadhar_file_link && ( 
                    <>
                         <label style={styles.label}>Fathers Aadhar</label>
                         <a target="_blank" href={father_aadhar_file_link}>View File</a>
                    </>
               )
              }

          </div>

       
          <div style={styles.fieldContainer}>
            <label style={styles.label}>Upload Mothers Aadhar</label>
            <input
             type="file" 
             id="mother_aadhar_file" 
             onChange={handleMotherAadharFileChange}   
            style={styles.input} />
              {mother_aadhar_file_link && ( 
                    <>
                         <label style={styles.label}>Mothers Aadhar</label>
                         <a target="_blank" href={mother_aadhar_file_link}>View File</a>
                    </>
               )
              }
          </div>

          <div style={styles.fieldContainer}>
            <label style={styles.label}>Upload Students Aadhar</label>
            <input
             type="file" 
             id="student_aadhar_file" 
             onChange={handleStudentAadharFileChange}   
            style={styles.input} />
              {student_aadhar_file_link && ( 
                    <>
                         <label style={styles.label}>Student Aadhar</label>
                         <a target="_blank" href={student_aadhar_file_link}>View File</a>
                    </>
               )
              }
          </div>

          <div style={styles.fieldContainer}>
            <label style={styles.label}>Upload Income Certificate</label>
            <input
             type="file" 
             id="student_income_file" 
             onChange={handleStudentIncomeFileChange}   
            style={styles.input} />
              {student_income_file_link && ( 
                    <>
                         <label style={styles.label}>Income Certificate</label>
                         <a target="_blank" href={student_income_file_link}>View File</a>
                    </>
               ) 
              }

          </div>

        </div>

        {sub_caste==="bohra" &&
            (  
              <>
                 <h2 style={styles.title}>Bohra ITS Documents</h2>
                 <div style={styles.fieldRow}>
                     <div style={styles.fieldContainer}>
                        <label style={styles.label}>Upload Fathers ITS</label>
                        <input
                        type="file" 
                        id="father_its_file" 
                        onChange={handleFatherITSFileChange}   
                        style={styles.input} />
                        {father_its_file_link && ( 
                                <>
                                    <label style={styles.label}>Fathers ITS</label>
                                    <a target="_blank" href={father_its_file_link}>View File</a>
                                </>
                        )
                        }

                    </div>


                    <div style={styles.fieldContainer}>
                        <label style={styles.label}>Upload Mothers ITS</label>
                        <input
                        type="file" 
                        id="mother_its_file" 
                        onChange={handleMotherITSFileChange}   
                        style={styles.input} />
                        {mother_its_file_link && ( 
                                <>
                                    <label style={styles.label}>Mothers ITS</label>
                                    <a target="_blank" href={mother_its_file_link}>View File</a>
                                </>
                        )
                        }

                    </div>


                    <div style={styles.fieldContainer}>
                        <label style={styles.label}>Upload Student ITS</label>
                        <input
                        type="file" 
                        id="student_its_file" 
                        onChange={handleStudentITSFileChange}   
                        style={styles.input} />
                        {student_its_file_link && ( 
                                <>
                                    <label style={styles.label}>Student ITS</label>
                                    <a target="_blank" href={student_its_file_link}>View File</a>
                                </>
                        )
                        }

                    </div>
                 </div>
              </>  
             
            )
        }
         <Circles
        height="80"
        width="80"
        color="#4A90E2"
        ariaLabel="circles-loading"
        wrapperStyle={{justifyContent: "center",
        alignItems: "center",}}
        wrapperClass=""
        visible={loading}
        />              
  
        <button type="submit"  onClick={handleSubmit} style={styles.button} 
           onMouseEnter={(e) => Object.assign(e.target.style, styles.hover)}
           onMouseLeave={(e) => Object.assign(e.target.style, styles.button)} 
        >Save</button>
      </form>
    )
}


const styles = {
    form: {
        maxWidth: '800px',
        margin: '0 auto',
        padding: '30px',
        backgroundColor: '#f3f4f6',
        borderRadius: '8px',
        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.1)',
        fontFamily: 'Arial, sans-serif',
    },
    title: {
        textAlign: 'center',
        fontSize: '1.5rem',
        color: '#333',
        marginBottom: '20px',
    },
    fieldRow: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
        justifyContent: 'space-between',
        marginBottom: '15px',
    },
    fieldContainer: {
        flex: '1 1 calc(50% - 10px)',
        marginBottom: '15px',
        display: 'flex',
        flexDirection: 'column',
    },
    label: {
        fontWeight: 'bold',
        fontSize: '0.9rem',
        color: '#555',
        marginBottom: '8px',
    },
    input: {
        padding: '10px 12px',
        borderRadius: '6px',
        border: '1px solid #d1d5db',
        backgroundColor: '#f9fafb',
        fontSize: '0.95rem',
        color: '#333',
        transition: 'border-color 0.3s ease',
    },
    inputFocus: {
        borderColor: '#E60240', // Accent color on focus
        outline: 'none',
    },
    link: {
        fontSize: '0.9rem',
        color: '#007bff',
        textDecoration: 'underline',
        cursor: 'pointer',
        marginTop: '5px',
        alignSelf: 'flex-start',
    },
    button: {
        width: '100%',
        backgroundColor: '#E60240',
        color: '#FFFFFF',
        padding: '12px 0',
        fontSize: '1rem',
        fontWeight: '600',
        borderRadius: '6px',
        border: 'none',
        cursor: 'pointer',
        transition: 'background-color 0.3s ease, transform 0.3s ease',
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
    },
    hover: {
        backgroundColor: '#c20035',
        transform: 'translateY(-2px)',
        boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.2)',
    },
};

export default StudentDocument;